import { Component, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { AccountFacade } from '../../../../account/store/facade';
import { Did } from '../../../../account/models';

@Component({
  selector: 'filter-did',
  templateUrl: './filter-did.component.html',
  styleUrls: ['./filter-did.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FilterDidComponent),
      multi: true
    }
  ]
})
export class FilterDidComponent implements ControlValueAccessor {

  public value: string;
  public onChange: any = () => { };
  public onTouch: any = () => { };

  public dids: Did[] = [];
  public selectedDid: Did;

  constructor(
    private accountFacade: AccountFacade
  ) {}

  ngOnInit() {
    this.accountFacade.pbx$.subscribe({
      next: (pbx) => {
        this.dids = pbx['dids'];
      }
    });
  }

  public selectDid(did: Did) {
    this.selectedDid = did;
    this.onChange(did?.number);
  }

  writeValue(obj: string): void {
    if (obj) {
      this.selectedDid = this.dids.find(did => did.number === obj);
      this.onChange(this.selectedDid?.number);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

}
